export default "__VITE_ASSET__MVdo97JDDoLmTAG1uzKtGg__"